import * as React from 'react'
import {
  GestureResponderEvent,
  Text,
  TouchableOpacity,
  View,
  ViewStyle,
  StyleSheet,
} from 'react-native'
import { wildSand, outerSpace, primary } from '@themes/Colors'
import Fonts from '@themes/Fonts'

type Props = {
  onPress: (event: GestureResponderEvent) => void
  text: string
  variation?: 'default' | 'small' | 'big'
  backgroundColor?: string
  textColor: string
  border?: boolean
  showBorder?: boolean
  disabled?: boolean
  style?: ViewStyle
  children?: React.ReactNode
}

export function RoundedButton({
  onPress,
  text,
  variation: preset = 'default',
  backgroundColor = wildSand,
  textColor = outerSpace,
  border,
  showBorder,
  disabled = false,
  style,
  children,
}: Props) {
  const btnStyle = () => (showBorder ? styles.borderBtn : styles.button)

  if (preset === 'small') {
    return (
      <View style={{ height: 31, width: 93 }}>
        <TouchableOpacity
          style={[
            styles.button,
            { borderRadius: 21, paddingHorizontal: 16 },
            { backgroundColor },
            border ? styles.borderBtn : {},
          ]}
          onPress={onPress}
        >
          <Text
            style={[
              styles.buttonText,
              {
                color: textColor,
                fontSize: Fonts.size.tiny,
                letterSpacing: 0.7,
              },
            ]}
          >
            {text || children || ''}
          </Text>
        </TouchableOpacity>
      </View>
    )
  } else if (preset === 'big') {
    return (
      <View style={{ height: 60 }}>
        <TouchableOpacity
          style={[
            btnStyle(),
            {
              backgroundColor,
              borderRadius: 30,
              paddingHorizontal: 22,
            },
          ]}
          onPress={onPress}
        >
          <Text
            style={[
              styles.buttonText,
              { color: textColor, fontSize: Fonts.size.regular },
            ]}
          >
            {text || children || ''}
          </Text>
        </TouchableOpacity>
      </View>
    )
  } else {
    return (
      <View style={{ paddingHorizontal: 16, height: 42 }}>
        <TouchableOpacity
          disabled={disabled}
          style={[
            btnStyle(),
            {
              backgroundColor,
              borderRadius: 21,
              paddingHorizontal: 16,
            },
          ]}
          onPress={onPress}
        >
          <Text
            style={[
              styles.buttonText,
              { color: textColor, fontSize: Fonts.size.small },
            ]}
          >
            {text || children || ''}
          </Text>
        </TouchableOpacity>
      </View>
    )
  }
}

const styles = StyleSheet.create({
  button: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonText: {
    textAlign: 'center',
    fontFamily: Fonts.type.sourceBold,
    fontWeight: 'bold',
    letterSpacing: 1,
    textTransform: 'uppercase',
  },
  borderBtn: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    borderColor: primary,
    borderWidth: 1,
  },
})
